import { createApp } from 'vue'
import router from './router'
import logger from './modules/logger'
import { createPinia } from 'pinia'
import App from './App.vue'
import ConfirmationDialog from "./components/common/ConfirmationDialog.vue";
import InformationDialog from "./components/common/InformationDialog.vue";
import { Loader } from '@progress/kendo-vue-indicators'
import { Userpilot } from 'userpilot'

const pinia = createPinia();
const app = createApp(App);

if (process.env.VUE_APP_UserpilotEnabled === 'true' || window.__env?.VUE_APP_UserpilotEnabled === 'true') {
    let userpilotToken = process.env.VUE_APP_UserpilotEnabled === 'true' ? process.env.VUE_APP_UserpilotToken : window.__env?.VUE_APP_UserpilotToken;
    Userpilot.initialize(userpilotToken)
}

app.use(pinia);
app.use(router);
app.use(logger);

app
    .component('KLoader', Loader)
    .component('ConfirmationDialog', ConfirmationDialog)
    .component('InformationDialog', InformationDialog);

app.mount('#app');


